import React, {lazy} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';

const WholesaleApplicationList = lazy(
  () => import('../../../modules/website/WholesaleApplication'),
);

const QuoteRequestList = lazy(
  () => import('../../../modules/website/QuoteRequest'),
);

const ContactMessageList = lazy(
  () => import('../../../modules/website/ContactMessage'),
);

const CategoryList = lazy(() => import('../../../modules/website/Category'));
const CreateCategory = lazy(
  () => import('../../../modules/website/Category/Create'),
);
const EditCategory = lazy(
  () => import('../../../modules/website/Category/Edit'),
);

const ProductList = lazy(() => import('../../../modules/website/Product'));
const CreateProduct = lazy(
  () => import('../../../modules/website/Product/Create'),
);
const EditProduct = lazy(() => import('../../../modules/website/Product/Edit'));

const ServiceList = lazy(() => import('../../../modules/website/Service'));
const CreateService = lazy(
  () => import('../../../modules/website/Service/Create'),
);
const EditService = lazy(() => import('../../../modules/website/Service/Edit'));

const FeatureList = lazy(() => import('../../../modules/website/Feature'));
const CreateFeature = lazy(
  () => import('../../../modules/website/Feature/Create'),
);
const EditFeature = lazy(() => import('../../../modules/website/Feature/Edit'));

const FaqList = lazy(() => import('../../../modules/website/Faq'));
const CreateFaq = lazy(() => import('../../../modules/website/Faq/Create'));
const EditFaq = lazy(() => import('../../../modules/website/Faq/Edit'));

const TestimonialList = lazy(
  () => import('../../../modules/website/Testimonial'),
);
const CreateTestimonial = lazy(
  () => import('../../../modules/website/Testimonial/Create'),
);
const EditTestimonial = lazy(
  () => import('../../../modules/website/Testimonial/Edit'),
);

const TrustItemList = lazy(() => import('../../../modules/website/TrustItem'));
const CreateTrustItem = lazy(
  () => import('../../../modules/website/TrustItem/Create'),
);
const EditTrustItem = lazy(
  () => import('../../../modules/website/TrustItem/Edit'),
);

const ProcessStepList = lazy(
  () => import('../../../modules/website/ProcessStep'),
);
const CreateProcessStep = lazy(
  () => import('../../../modules/website/ProcessStep/Create'),
);
const EditProcessStep = lazy(
  () => import('../../../modules/website/ProcessStep/Edit'),
);

const SiteSettingsPage = lazy(
  () => import('../../../modules/website/SiteSettings'),
);

const ContentPageList = lazy(
  () => import('../../../modules/website/ContentPage'),
);
const CreateContentPage = lazy(
  () => import('../../../modules/website/ContentPage/Create'),
);
const EditContentPage = lazy(
  () => import('../../../modules/website/ContentPage/Edit'),
);

export const websiteContentConfigs = [
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/category',
    element: <CategoryList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/category/create',
    element: <CreateCategory />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/category/edit/:id',
    element: <EditCategory />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/product',
    element: <ProductList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/product/create',
    element: <CreateProduct />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/product/edit/:id',
    element: <EditProduct />,
  },
  // Service
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/service',
    element: <ServiceList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/service/create',
    element: <CreateService />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/service/edit/:id',
    element: <EditService />,
  },
  // Feature
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/feature',
    element: <FeatureList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/feature/create',
    element: <CreateFeature />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/feature/edit/:id',
    element: <EditFeature />,
  },
  // FAQ
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/faq',
    element: <FaqList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/faq/create',
    element: <CreateFaq />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/faq/edit/:id',
    element: <EditFaq />,
  },
  // Testimonial
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/testimonial',
    element: <TestimonialList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/testimonial/create',
    element: <CreateTestimonial />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/testimonial/edit/:id',
    element: <EditTestimonial />,
  },
  // Trust Item
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/trust-item',
    element: <TrustItemList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/trust-item/create',
    element: <CreateTrustItem />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/trust-item/edit/:id',
    element: <EditTrustItem />,
  },
  // Process Step
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/process-step',
    element: <ProcessStepList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/process-step/create',
    element: <CreateProcessStep />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/process-step/edit/:id',
    element: <EditProcessStep />,
  },
  // Content Pages
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/pages',
    element: <ContentPageList />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/pages/create',
    element: <CreateContentPage />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/pages/edit/:id',
    element: <EditContentPage />,
  },
  // Site Settings (singleton)
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/site-settings',
    element: <SiteSettingsPage />,
  },
  // Wholesale Applications (inbox)
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/wholesale-application',
    element: <WholesaleApplicationList />,
  },
  // Quote Requests (inbox)
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/quote-request',
    element: <QuoteRequestList />,
  },
  // Contact Messages (inbox)
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/website/contact-message',
    element: <ContactMessageList />,
  },
];
